import * as types from './types';

const fetchInfoSeeker = id => ({ type: types.FETCH_SEEKER_INFO, payload: id });
const fetchInfoSeekerSucceeded = data => ({ type: types.FETCH_SEEKER_INFO_SUCCEEDED, payload: data });
const fetchInfoSeekerFailed = error => ({ type: types.FETCH_SEEKER_INFO_SUCCEEDED, payload: error });

export { fetchInfoSeeker, fetchInfoSeekerFailed, fetchInfoSeekerSucceeded };
